import store from '../store/store';

export default function updateRecentlyRejectedSuggestionsTelemetryWithCharacterTyped(
    characterTyped: string
) {
    const recentlyRejectedSuggestionsTelemetry = store().recentlyRejectedSuggestionsTelemetry;
    if (recentlyRejectedSuggestionsTelemetry) {
        recentlyRejectedSuggestionsTelemetry.forEach(rejectedSuggestionTelemetry => {
            rejectedSuggestionTelemetry.charactersTypedAfterRejection += characterTyped;
        });
    }
}
